export const BxCopy = (props: React.SVGProps<SVGSVGElement>): JSX.Element => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.668 0.666656H7.33464C6.41547 0.666656 5.66797 1.41416 5.66797 2.33332V5.66666H2.33464C1.41547 5.66666 0.667969 6.41416 0.667969 7.33332V15.6667C0.667969 16.5858 1.41547 17.3333 2.33464 17.3333H10.668C11.5871 17.3333 12.3346 16.5858 12.3346 15.6667V12.3333H15.668C16.5871 12.3333 17.3346 11.5858 17.3346 10.6667V2.33332C17.3346 1.41416 16.5871 0.666656 15.668 0.666656ZM2.33464 15.6667V7.33332H10.668L10.6696 15.6667H2.33464ZM15.668 10.6667H12.3346V7.33332C12.3346 6.41416 11.5871 5.66666 10.668 5.66666H7.33464V2.33332H15.668V10.6667Z"
        fill="#272D41"
      />
    </svg>
  )
}

export default BxCopy
